/**
 * Forma unica de respuesta para los servicios: { ok, data, total, error }.
 *
 * Contrato del back:
 *   code 1  <->  errcode 0     todo bien
 *   code 0  <->  errcode != 0  error, y el errcode dice cual
 *
 * `code` decide si anduvo; `errcode` y `errmsg` solo explican el error. Se mira un solo
 * campo y no los dos: si algun dia el back manda un code 1 con un errcode de aviso,
 * chequear ambos lo leeria como error sin motivo.
 *
 * Sirve igual para los cuatro verbos. Un Ins, un Upd o un Del exitosos devuelven
 * result vacio, asi que `data` queda en [] y el llamador solo mira `ok`.
 *
 * EL MENSAJE DEL BACK SOLO SE USA EN EL ERROR, y por eso solo viaja en `error`. En el
 * exito manda `OK` casi siempre, asi que el texto que ve el usuario —"Feriado creado
 * correctamente"— lo pone cada pantalla.
 */
export const respuestaDe = (respuesta) => {
  // El `?? {}` cubre un caso real: cuando la sesion expira, axiosPost hace
  // window.location.assign(...) y devuelve undefined. Sin eso, desestructurar rompe.
  const { status, result } = respuesta ?? {};

  if (status?.code !== 1) {
    return {
      ok: false,
      data: [],
      total: 0,
      error: {
        codigo: status?.errcode,
        mensaje: status?.errmsg,
      },
    };
  }

  // `data` siempre es un array, aunque el back mande null u otra cosa: asi el llamador
  // puede hacer .map o .length sin preguntar nada antes.
  const data = Array.isArray(result) ? result : [];

  return {
    ok: true,
    data,
    // El back manda `totalRegistros` repetido en cada fila. Cuando hay paginado del
    // lado del server es el total real y `data.length` solo el tamaño de la pagina;
    // cuando no lo hay, los dos coinciden. Si el servicio no lo devuelve, el total es
    // lo que trajimos, que tambien es correcto.
    total: data[0]?.totalRegistros ?? data.length,
    error: null,
  };
};
